import React, { useReducer, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import { getUserDetails } from "../components/sidebar/Sidenav";
import { getAPIUrl, notify, ValidateInputField } from "../components/common/helpers";
import { getAuthToken } from "../api/api";
import Tooltip from "../components/common/ToolTip";
import { ReactComponent as Close } from "../../src/icons-svg/icons/close.svg";
import axios from "axios";
import "../styles/Modal.css";
import {DraggableModalDialog} from "../components/common/DraggableModal"

const AddContract = (props) => {
  const { disabledFeatures, getContracts, isEdit, setEdit, rowEntries } = props;

  const controller = new AbortController();
  const formReducer = (state, action) => {
    switch (action.type) {
      case "SET_FIELD_VALUE":
        return {
          ...state,
          formData: {
            ...state.formData,
            [action.field]: action.value,
          },
        };
      case "SET_FORM_ERRORS":
        return {
          ...state,
          formErrors: {
            ...state.formErrors,
            [action.field]: action.error,
          },
        };
      case "SET_VALIDATED":
        return {
          ...state,
          validated: action.validated,
        };
        case "SET_COMPONENT_TYPES":
            return {
              ...state,
              componentTypeOptions: action.componentTypeOptions,
            };
        case "SET_SITE_OPTIONS":
        return {
          ...state,
          siteOptions: action.siteOptions,
        };
        case "SET_SELECTED_SITE":
        return {
          ...state,
          selectedSite: action.selectedSite,
        };
            case "SET_SELECTED_COMPONENT_ID":
            return {
              ...state,
              selectedComponentID: action.selectedComponentID,
            };

            case "SET_SELECTED_COMPONENT_TYPE":
                return {
                  ...state,
                  selectedComponentType: action.selectedComponentType,
                };
      case "SET_SHOW":
        return {
          ...state,
          show: action.show,
        };
      case "RESET_FORM":
        return initialState;

      default:
        return state;
    }
  };

  const initialState = {
    formData: {
        contract_number: isEdit ? rowEntries.contract_number : "" ,
    },
    formErrors: {
        contract_number: "",
    },
    siteOptions : [],
    componentTypeOptions: [],
    selectedSite: isEdit ? rowEntries.building_name : "",
    selectedComponentType: isEdit ? rowEntries.component_types.split(",") : [],
    selectedComponentID:  isEdit ? JSON.stringify(rowEntries.component_type_id).split(",") : [],
    validated: false,
    show: false,
    rowdata: {},
  };

  const [state, dispatch] = useReducer(formReducer, initialState);
  const { formData, formErrors, validated, show, siteOptions, selectedSite, componentTypeOptions, selectedComponentType, selectedComponentID } = state;

  const isEditChecker = () => {
    return isEdit && isEdit !== null
  }

  const handleClose = () => {
    if(controller) {
      controller.abort();
    }
    dispatch({ type: "SET_SHOW", show: false });
    dispatch({ type: "RESET_FORM" });
    isEdit && setEdit(false);
  };
  const handleShow = () => dispatch({ type: "SET_SHOW", show: true });

  const handleChanged = (e) => {
    dispatch({ type: "SET_SELECTED_SITE", selectedSite: e.label });
  };

  const setSelectedSite = () => {
    if (isEdit) {
      return siteOptions.filter((obj) => selectedSite === obj.label);
    } else if (selectedSite !== "") {
        return siteOptions.filter((obj) => selectedSite === obj.label);
      } else {
        return siteOptions[0];
      }
  };

  const defaultValidation = () => {
    return Object.values(formErrors).every((error) => error === "valid" || error === "") &&
    formData.contract_number &&
    selectedSite !== undefined &&
    selectedComponentType.length !== 0
  }

  const isFormValid = () => {
    if (isEdit) {
      return (defaultValidation() && (JSON.stringify(formData) !== JSON.stringify(initialState["formData"]) || 
      JSON.stringify(selectedSite) !== JSON.stringify(initialState.selectedSite) || 
      JSON.stringify(selectedComponentType) !== JSON.stringify(initialState.selectedComponentType)))
    } else {
      return defaultValidation();
    }
  };

  // Get Site dropdown values
  useEffect(() => {
    if (show || isEdit) {
      axios({
        method: "GET",
        url: getAPIUrl("getSiteListApi"),
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
        .then((res) => {
          let formatOption;
          if (res && res.data.code !== 404) {
            formatOption = res.data.map((item) => ({
              value: item.site_id,
              label: item.building_name,
            }));
           dispatch({ type: "SET_SITE_OPTIONS", siteOptions: formatOption });
          }
        })
        .catch((err) => {
            dispatch({ type: "SET_SITE_OPTIONS", siteOptions: [] });
        });
    }

    return () => {
      controller.abort();
    };
  }, [show, isEdit]);

  // Get default component type data
  useEffect(() => {
    if (show || isEdit) {
      axios({
        method: "GET",
        url: getAPIUrl("getComponentTypeApi"),
        headers: {
          Authorization: getAuthToken(),
        },
        signal: controller.signal,
      })
        .then((res) => {
          const formateOptions = res.data.map((item) => ({
            value: item.component_type_id,
            label: item.component_type,
          }));
          dispatch({ type: "SET_COMPONENT_TYPES", componentTypeOptions: formateOptions });
        })
        .catch((error) => {
          dispatch({ type: "SET_COMPONENT_TYPES", componentTypeOptions: [] });
          console.log(error);
        });
    }
    
    return () => {
      controller.abort();
    };
  }, [show, isEdit])

  //Add a function to handle changes to the form input
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const error = ValidateInputField(name, value);

    dispatch({ type: "SET_FIELD_VALUE", field: name, value });
    dispatch({ type: "SET_FORM_ERRORS", field: name, error });
  };

  // handle onChange event of the dropdown
  const handleComponentTypeChanged = (event) => {
    let componentTypeList = [];
    let componentTypeIdList = [];
    Object.values(event).map((f) => componentTypeList.push(f.label));
    Object.values(event).map((f) => componentTypeIdList.push(f.value));
    dispatch({ type: "SET_SELECTED_COMPONENT_TYPE", selectedComponentType: componentTypeList });
    dispatch({ type: "SET_SELECTED_COMPONENT_ID", selectedComponentID: componentTypeIdList });
    const error = ValidateInputField("component_type_id", componentTypeList);
    dispatch({ type: "SET_FORM_ERRORS", field: "component_type_id", error });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form_Data = new FormData(event.target);
    const userid = isEditChecker() ? "updated_by" : "created_by";
    isEditChecker() && form_Data.append("remark" ,"update_data");
    isEditChecker() && form_Data.append("contract_id", rowEntries.contract_id);
    form_Data.append(userid, getUserDetails().username);
    form_Data.append("component_types", selectedComponentType);
    form_Data.append("component_type_id", selectedComponentID);
    const formDataObject  = Object.fromEntries(form_Data.entries());
  
    if (isEditChecker()) {
      try {
        axios({
          method: "PATCH",
          url: getAPIUrl("updateSiteContractDetails"),
          headers: {
            Authorization: getAuthToken(),
          },
          signal: controller.signal,
          data: formDataObject,
        })
          .then((res) => {
            if (res) {
              handleClose();
              alert("Contract Details Updated Successfully");
              setTimeout(() => {
                getContracts();
              }, 3000);
            }
          })
          .catch((error) => {
            error.message !== "canceled" && notify("updating");
          });
      } catch (error) {
        console.log("Error fetching data:" + error);
      }
    } else {
      try {
        axios({
          method: "POST",
          url: getAPIUrl("addSiteContractDetails"),
          headers: {
            Authorization: getAuthToken(),
          },
          signal: controller.signal,
          data: formDataObject,
        })
          .then((res) => {
            if (res && res.data.code === 200) {
              handleClose();
              alert("Contract Details Added Successfully");
              setTimeout(() => {
                getContracts();
              }, 3000);
            } else if(res && res.data.code === 5050){
              alert("Contract Already Exists");
            }
          })
          .catch((error) => {
            error.message !== "canceled" && notify("submission");
          });
      } catch (error) {
        console.log("Error fetching data:" + error);
      }
    }
    dispatch({ type: "SET_VALIDATED", validated: false });
  };

  return (
    <>
      {" "}
      {!isEdit && (!disabledFeatures.includes("AddContract")) && (
        <Button
          size="sm"
          variant="secondary"
          style={{ background: "#ffffff", color: "#000000", width: "120px" }}
          onClick={handleShow}
        >
          +Add Contract
        </Button>
      )}
      <Modal
        show={show || isEdit}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        dialogAs={DraggableModalDialog}
      >
        <Modal.Header className="cancelButton">
          <Modal.Title style={{ color: "#ffffff" }}>
            <Row>
            <Col sm={{ span: 7 }}>
            <h3>{isEditChecker()? "Edit Contract Details" : "Add Contract"}</h3>
                  </Col>
                  <Col sm={{ offset: 3 }}>
                <Button
                    className="col-md-8 hoverEffect"
                    size="sm" 
                    variant="Dark"
                    onClick={handleClose}
                    aria-label="Close Button"
                  >
                    <Close/>
                  </Button>
                  </Col>
            </Row>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ background: "#212529" }}>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
          <Row className="mb-3">
                <Form.Group as={Row} md="12" className="formField">
                  <Form.Label
                    className="required"
                    style={{ color: "white" }}
                    size="sm"
                    column
                    sm={4}
                    htmlFor="contract number"
                  >
                   Contract Number
                  </Form.Label>
                  <Col sm={8}>
                    <Form.Control
                      size="sm"
                      aria-required
                      type="text"
                      readOnly={isEdit}
                      placeholder="Contract Number"
                      id="validationCustom01"
                      name="contract_number"
                      maxLength={30}
                      value={
                        formData.contract_number.charAt(0).toUpperCase() +
                        formData.contract_number.slice(1)
                      }
                      aria-invalid={formErrors.contract_number === "error"}
                      onChange={handleInputChange}
                      isInvalid={formErrors.contract_number === "error"}
                      isValid={formErrors.contract_number === "valid"}
                    />
                    {formErrors.contract_number === "error" && (
                      <Tooltip type = "contract_number" charLength={3} specialCharException={"-, _"} required={true}/>
                  )}
                  </Col>
                </Form.Group>
              </Row>
          <Row className="mb-3">
                <Form.Group
                  as={Row}
                  md="12"
                  name="site"
                  className="formField"
                >
                  <Form.Label
                    className="required"
                    style={{ color: "white" }}
                    size="sm"
                    column
                    sm={4}
                    htmlFor="site"
                  >
                    Site
                  </Form.Label>
                  <Col sm={8}>
                    <Select
                      size="sm"
                      name="site_id"
                      onChange={handleChanged}
                      aria-required
                      value={setSelectedSite()}
                      options={siteOptions}
                    >
                    </Select>
                  </Col>
                  <Col sm={12}>
                    <Form.Control.Feedback type="invalid">
                      Please select a valid site.
                    </Form.Control.Feedback>
                  </Col>
                </Form.Group>
              </Row>
              <Row className="mb-3 ">
              <Form.Group
                as={Row}
                md="12"
                className="formField"
              >
                <Form.Label
                  className="required"
                  style={{ color: "white" }}
                  size="sm"
                  column
                  sm={4}
                  htmlFor="component type"
                  aria-label="component type"
                >
                  Component Type
                </Form.Label>
                <Col sm={8}>
                  <div>
                    <Select
                      size="sm"
                      aria-invalid={formErrors.component_type === "error"}
                      isInvalid={formErrors.component_type === "error"}
                      isValid={formErrors.component_type === "valid"}
                      className={
                        (formErrors.component_type === "error")
                          ? "error form-control form-control-sm"
                          : "form-control form-control-sm"
                      }
                      placeholder="Ex:[ComponentType]"
                      value={componentTypeOptions.filter((obj) =>
                        selectedComponentType.includes(obj.label)
                      )} 
                     // set list of the data
                      options={componentTypeOptions}
                      onChange={handleComponentTypeChanged} // assign onChange function
                      isMulti
                      isClearable
                      aria-required
                      name="component_type_id"
                    />
                  </div>
                  {( formErrors.component_type_id === "error") && (
                    <Tooltip type="componentType_selection"/>
                  )}
                </Col>
              </Form.Group>
            </Row>
            <Row>
              <Col sm={{ span: 10, offset: 2 }}>
                  <Button
                    className="col-md-5"
                    size="sm"
                    variant="secondary"
                    type="submit"
                    disabled={!isFormValid()}
                  >
                    {isEditChecker()? "Update" : "Submit"}
                  </Button>
                {" "}
                <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  onClick={handleClose}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddContract;
